'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Modal = function () {
  function Modal($uibModal) {
    'ngInject';

    _classCallCheck(this, Modal);

    this._$uibModal = $uibModal;
  }

  _createClass(Modal, [{
    key: 'payment',
    value: function payment() {
      var _text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Enter credit card information below.';

      var _title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Payment';

      var _application = arguments[2];
      var size = arguments[3];

      var modalInstance = this._$uibModal.open({
        animation: true,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        template: require('./cardModal.html'),
        controller: 'ModalController',
        controllerAs: '$ctrl',
        size: size,
        resolve: {
          text: function text() {
            return _text;
          },
          title: function title() {
            return _title;
          },
          application: function application() {
            return _application;
          }
        }
      });

      return modalInstance.result;
    }
  }, {
    key: 'confirmation',
    value: function confirmation() {
      var _text2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Are you sure you want to do that?';

      var _title2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Confirm';

      var size = arguments[2];

      var modalInstance = this._$uibModal.open({
        animation: true,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        template: require('./confirmModal.html'),
        controller: 'ModalController',
        controllerAs: '$ctrl',
        size: size,
        resolve: {
          text: function text() {
            return _text2;
          },
          title: function title() {
            return _title2;
          },
          application: function application() {
            return {};
          }
        }
      });

      return modalInstance.result;
    }
  }, {
    key: 'accept',
    value: function accept() {
      var _text3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Are you sure you want to do that?';

      var _title3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Confirm';

      var _application2 = arguments[2];
      var size = arguments[3];

      var modalInstance = this._$uibModal.open({
        animation: true,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        template: require('./acceptModal.html'),
        controller: 'ModalController',
        controllerAs: '$ctrl',
        size: size,
        resolve: {
          text: function text() {
            return _text3;
          },
          title: function title() {
            return _title3;
          },
          application: function application() {
            return _application2;
          }
        }
      });

      return modalInstance.result;
    }
  }, {
    key: 'manual',
    value: function manual() {
      var _text4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Are you sure you want to do that?';

      var _title4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Confirm';

      var size = arguments[2];

      var modalInstance = this._$uibModal.open({
        animation: true,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        template: require('./paymentModal.html'),
        controller: 'ModalController',
        controllerAs: '$ctrl',
        size: size,
        resolve: {
          text: function text() {
            return _text4;
          },
          title: function title() {
            return _title4;
          },
          application: function application() {
            return {};
          }
        }
      });

      return modalInstance.result;
    }
  }, {
    key: 'acceptOther',
    value: function acceptOther() {
      var _text5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Are you sure you want to do that?';

      var _title5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Confirm';

      var size = arguments[2];

      var modalInstance = this._$uibModal.open({
        animation: true,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        template: require('./acceptOtherModal.html'),
        controller: 'ModalController',
        controllerAs: '$ctrl',
        size: size,
        resolve: {
          text: function text() {
            return _text5;
          },
          title: function title() {
            return _title5;
          },
          application: function application() {
            return {};
          }
        }
      });

      return modalInstance.result;
    }
  }]);

  return Modal;
}();

exports.default = Modal;


// WEBPACK FOOTER //
// ./client/components/modal/modal.service.js